<template>
    <div v-click-outside="handleClickOutside" class="max-sm:w-full">
        <SearchFilterButton2
            buttonText="Property Name"
            :selectedCounter="showCounter"
            srLabel="Search properties by name"
            @clicked="handleClicked"
            :selected="selectedProperties"
            :disabled="isDisabled"
        />
        <transition
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-show="open" class="relative">
                <AutoSuggest
                    v-if="dropdownType === 'links'"
                    url="/hotels/namesearch?search="
                    inputName="hotelName"
                    resultsArrayKey="data"
                    :requireInput="false"
                    placeholder="Property Name"
                    @handleSelect="handleSelect"
                    @blur="handleClickOutside"
                    :preloadData="preloadData"
                    :preloadedItems="filteredSearchResults"
                />
                <AutoSuggestWithCheckboxes
                    v-if="dropdownType === 'select'"
                    url="/hotels/namesearch?search="
                    inputName="hotelName"
                    resultsArrayKey="data"
                    :requireInput="false"
                    placeholder="Property Name"
                    :preloadData="true"
                    :preSelectedOptions="selectedProperties"
                    :preloadedItems="alertProperties"
                    @handleCheck="handleCheck"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import { useAlertsStore } from '@/store/alerts';
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';
import AutoSuggest from '@/components/ui/auto-suggest.vue';
import AutoSuggestWithCheckboxes from '@/components/ui/autosuggest-with-checkboxes/autosuggest-with-checkboxes.vue';
import SearchFilterButton2 from '@/components/hotels/search/search-filter-button/search-filter-button-2.vue';
import vClickOutside from 'click-outside-vue3';

export default {
    name: 'SearchByName',
    components: {
        AutoSuggest,
        AutoSuggestWithCheckboxes,
        SearchFilterButton2,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    emits: ['handleSelect'],
    props: {
        preloadData: {
            type: Boolean,
            required: false,
            default: true,
        },
        dropdownType: {
            type: String,
            required: false,
            default: 'links',
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(props, { emit }) {
        const hotelsStore = useHotelsStore();
        const alertsStore = useAlertsStore();
        const { filteredSearchResults } = storeToRefs(hotelsStore);
        const { alertProperties } = storeToRefs(alertsStore);
        const { property } = storeToRefs(hotelsStore);
        const router = useRouter();
        const showInput = ref(false);
        const open = ref(false);
        const { selectedProperties } = storeToRefs(alertsStore);
        const showCounter = computed(() =>
            props.dropdownType === 'links' ? false : true
        );
        const handleClicked = () => {
            open.value = !open.value;
        };
        const toggleShowInput = () => {
            showInput.value = !showInput.value;
        };
        const handleSelect = (data) => {
            open.value = false;
            if (data.route) {
                router.push(`/hotels/properties/${data.slug}`);
            }
            if (!data.route) {
                emit('handleSelect', data);
            }
        };

        const handleCheck = (val) => {
            alertsStore.setSelectedProperties(val.id);
            alertsStore.setAlertsViewFilters(val.id);
            alertsStore.clearSelectedGroups();
        };

        const handleClickOutside = () => {
            open.value = false;
        };

        return {
            alertProperties,
            open,
            handleClicked,
            filteredSearchResults,
            handleCheck,
            handleSelect,
            showInput,
            toggleShowInput,
            handleClickOutside,
            selectedProperties,
            property,
            showCounter,
        };
    },
};
</script>
